import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AppClipsComponent} from './app-clips/app-clips.component';


@NgModule({
    declarations: [
        AppClipsComponent
    ],
    exports: [
        AppClipsComponent
    ],
    imports: [
        CommonModule
    ]
})
export class AppClipsModule { }
